export type CanonicalProvider =
  | 'openAi'
  | 'anthropic'
  | 'gemini'
  | 'groq'
  | 'perplexity'
  | 'xai'
  | 'palm'
  | 'openSources'
  | 'stabilityAi'
  | 'ideogram'
  | 'fal'
  | 'replicate'
  | 'runwayMl'
  | 'clipDrop'
  | 'mistral'
  | 'evenLabs'
  | 'playHt';

export type Modality = 'text' | 'image' | 'audio' | 'voice';

const NORMALIZE: Record<string, CanonicalProvider> = {
  openai: 'openAi',
  anthropic: 'anthropic',
  anthropicai: 'anthropic',
  gemini: 'gemini',
  google: 'gemini',
  groq: 'groq',
  perplexity: 'perplexity',
  perplexityai: 'perplexity',
  xai: 'xai',
  palm: 'palm',
  opensources: 'openSources',
  opensource: 'openSources',
  opensourcemodel: 'openSources',
  stabilityai: 'stabilityAi',
  stability: 'stabilityAi',
  ideogram: 'ideogram',
  fal: 'fal',
  replicate: 'replicate',
  runwayml: 'runwayMl',
  clipdrop: 'clipDrop',
  mistral: 'mistral',
  evenlabs: 'evenLabs',
  elevenlabs: 'evenLabs',
  'elevenlabs.io': 'evenLabs',
  playht: 'playHt',
  'play.ht': 'playHt',
};

export function normalizeProvider(raw?: string | null): CanonicalProvider | null {
  if (!raw) return null;
  const key = String(raw).trim().toLowerCase();
  return NORMALIZE[key] ?? null;
}
